import { orderInformationStyles as styles } from "@insite/content-library/Widgets/OrderApprovalDetails/OrderApprovalDetailsOrderInformation";
import { css } from "styled-components";


// Verndale Customization: Ticket TGGOPT-2281

styles.mainInformationGridItem = {
    ...styles.mainInformationGridItem,
    width: 11,
};